import { Injectable } from '@angular/core';
import { Category } from 'src-ironside/repositories/category.repository';

export type FilterData = {
    categories?: string[] | null;
    departments?: string | null;
    research?: string | null;
    createDate?: string | null;
    suppliers?: string[] | null;
    partners?: string[] | null;
    isNewProduct?: boolean | null;
    favListId?: string;
    favListName?:string;
    categoryName?: string | null;
    manufactoringCountry?:string[]|null;
    packaging?:string[]|null;
    categoryList?:Category[]
    categoryId?:string;
};

@Injectable({
    providedIn: 'root',
})
export class AccueilDataService {
    constructor() {}
    _filterData: FilterData;

    set filterData(value: FilterData) {
        this._filterData = value;
    }

    get filterData() {
        return this._filterData;
    }
}
